// src/components/navigation/AccountMenu.tsx
import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import MenuItem from './shared/MenuItem';
import './AccountMenu.scss';

interface AccountMenuItem {
  type: 'link';
  label: string;
  onClick?: () => void;
}

interface AccountMenuProps {
  menu: AccountMenuItem[];
}

const AccountMenu: React.FC<AccountMenuProps> = ({ menu }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const toggleMenu = () => setOpen((prev) => !prev);

  const handleItemClick = (item: AccountMenuItem) => {
    if (item.onClick) {
      item.onClick();
    } else {
      console.warn('AccountMenu: item has no handler', item);
    }
    setOpen(false);
  };

  return (
    <div className="accountmenu-container" ref={menuRef}>
      <button className="accountmenu-trigger" onClick={toggleMenu}>
        <FontAwesomeIcon icon={faUser} />
        <span className="accountmenu-label"> My Account </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`accountmenu-chevron ${open ? 'open' : ''}`}
        />
      </button>

      {open && (
        <div className="accountmenu-dropdown">
          {menu.map((item, idx) => (
            <MenuItem key={idx} onClick={() => handleItemClick(item)}>
              {item.label}
            </MenuItem>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
